import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { getContext } from "../../Helpers/Context/Context";
import { a11yProps } from "../../Helpers/CustomTabPanel/CustomTabPanel";

import notify, { ToastType } from "../../Helpers/ToastNotification";
import axios from "axios";
import fileDownload from "js-file-download";
import moment from "moment";
import { GetDemandRecoveryExportToExcel } from "../../Helpers/APIEndPoints/EndPoints";
import { fetchAuthToken } from "../../Helpers/Network/OAuthHandler";
import { StyledBadge } from "../RegistrationRequest/RegistrationRequest";
import { Tooltip } from "@mui/material";
import ButtonComponent from "../../Components/ButtonForm/Button";

import { RoleEnum } from "../../Helpers/Enums/RoleEnum";
import { useNavigate } from "react-router-dom";
import { IDRRFilters } from "./Grid/IDDRGrid";
import { IDRRTabs } from "./IDRRTabs";
import { DRREnums } from "./Enums/DRREnums";
import DRRGrid from "./Grid/DRRGrid";
import DRRFilters from "./Filters/DRRFilters";

import Modal from "react-modal"; //added by Imman on 17-07-2024
import { Height } from "@mui/icons-material";
//import "../style.css";
const DemandRecoveryDashboard = () => {
  const location = useLocation();
  const context = getContext();
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [dataCount, setDataCount] = useState(0);
  const [pageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [dashboardFilterOn, setDashboardFilterOn] = useState<boolean>(false);
  const [currentDataReqObj, setCurrentDataReqObj] = useState(null);
  const [currentFilters, setCurrentFilters] = useState<IDRRFilters>(null);
  const [showPopUp, setShowPopUp] = useState<boolean>(false); //added by Imman on 17-07-2024
  const [keywords, setKeywords] = useState("");
  const [tabs, setTabs] = useState<IDRRTabs[]>([
    {
      label: "Records",
      value: { ...a11yProps(0) },
      count: 0,
      active: true,
      visible: true,
      id: "Records",
      target: DRREnums.Records,
      module: DRREnums.Records,
    },
  ]);

  const changeTab = (tabNum) => {
    const newTabs = [...tabs];
    newTabs.forEach((nt) => (nt.active = false));
    newTabs[tabNum].active = true;
    setTabs(newTabs);
  };

  const ExportToExcel = async (
    count,
    searchText,
    sortColumn,
    sortDirection,
    MemberId,
    UnitCodeId,
    TypeofApplicantId,
    FromDate,
    ToDate,
    Status,
    IsApproval,
    IsAgreement,
    IsFinalDisbursement,
    currentRoleId,
    userId,
    activeTab
  ) => {
    
    const params = {
      resultsPerPage: count,
      searchText: searchText,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      MemberId: MemberId,
      UnitCodeId: UnitCodeId,
      TypeofApplicantId: TypeofApplicantId,
      FromDate: FromDate,
      ToDate: ToDate,
      Status: Status,
      IsApproval: IsApproval,
      IsAgreement: IsAgreement,
      IsFinalDisbursement: IsFinalDisbursement,
      RoleId: currentRoleId,
      UserId: userId,
      ActiveModule: [DRREnums.Records].includes(activeTab.module) ? 1 : 0,
    };
    let token = await fetchAuthToken();
    axios
      .request({
        responseType: "blob",
        method: "POST",
        url: GetDemandRecoveryExportToExcel,
        data: params,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
     
        fileDownload(
          response.data,
          `StatmentRequest_` +
            `${moment(new Date()).format(moment.HTML5_FMT.DATE)}` +
            `.xlsx`
        );
      })
      .catch((error) => {
     
        notify(ToastType.Error, "Failed to export data.");
      });
  };

  const handleEvents = (target: DRREnums, event: any = null) => {
    let activeTabs = tabs.find((t) => t.active);

    switch (target) {
      case DRREnums.Records:
        changeTab(0);
        break;
      // case StatmentRequestEnums.Pendeing:
      //   changeTab(1);
      //   break;
      //   case StatmentRequestEnums.TabAgreementRequestClick:
      //     changeTab(2);
      //     break;
      //   case StatmentRequestEnums.TabFinalDisbursementClick:
      //     changeTab(3);
      //     break;
      case DRREnums.FilterClick:
        setDashboardFilterOn(!dashboardFilterOn);
        break;
      case DRREnums.SearchClick:
        setSearchText(event?.target?.value);
        break;
      case DRREnums.ExportToExcelClick:
        
        if (dataCount === 0) {
          notify(ToastType.Error, "No data available");
        } else {
          ExportToExcel(
            dataCount,
            currentDataReqObj.searchText,
            currentDataReqObj.sortColumn,
            currentDataReqObj.sortDirection,
            currentDataReqObj.MemberId,
            currentDataReqObj.UnitCodeId,
            currentDataReqObj.TypeofApplicantId,
            currentDataReqObj.FromDate,
            currentDataReqObj.ToDate,
            currentDataReqObj.Status,
            currentDataReqObj.IsApproval,
            currentDataReqObj.IsAgreement,
            currentDataReqObj.IsFinalDisbursement,
            context?.CurrentRoleId,
            context?.Id,
            activeTabs
          );
        }
        break;
    }
  };

  const TabsComponent = ({ tab }) => {
    const { count, active, id, target, label } = tab;

    return (
      <StyledBadge
        badgeContent={count}
        color="error"
        className="mr-3"
        max={99}
        invisible={true}
      >
        <li className="nav-item" role="presentation">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a
            key="Dashboard"
            className={active ? "nav-link active" : "nav-link"}
            id={id}
            data-toggle="pill"
            role="tab"
            aria-controls="pills-MA"
            aria-selected={active ? "true" : "false"}
            onClick={() => handleEvents(target)}
          >
            {label}
          </a>
        </li>
      </StyledBadge>
    );
  };

  return (
    <>
      <div className="">
        <div className="">
          <div className="clearfix"></div>
          <div className="page-content row filter-row-container m-0 no-gutters">
            <div className="transformer-tabs col-lg-12 col-md-12">
              <div className="meeting-tabs tabs-main col-lg-12 p-0">
                {/* <div className="page-content row filter-row-container mb-0 ml-0 mr-0"> */}
                <div className="col-lg-12 p-0">
                  <div className="row">
                    <div className="col-lg-6 no-gutters">
                      <nav className="tabs mr-sm-4 --jsfied">
                        <ul
                          className="nav nav-pills  float-left"
                          id="pills-tab"
                          role="tablist"
                        >
                          {tabs.map((tab) => {
                            if (!tab.visible) return null;
                            return <TabsComponent tab={tab} key={tab.id} />;
                          })}
                        </ul>
                      </nav>
                    </div>
                    <div className="col-lg-6 d-flex justify-content-end no-gutters">
                      <div className="col-lg-6">
                        <div className="input-group">
                          <input
                            className="form-control py-2 border-right-0 border"
                            type="filter"
                            value={searchText}
                            placeholder="Search"
                            onChange={(e) => setSearchText(e.target.value)}
                          />
                          <span className="input-group-append">
                            <div className="input-group-text bg-transparent">
                              <i className="fa fa-search"></i>
                            </div>
                          </span>
                        </div>
                      </div>
                      <Tooltip
                        title="Filters"
                        style={{ marginLeft: "5px", cursor: "pointer" }}
                      >
                        <ButtonComponent
                          onClick={() => handleEvents(DRREnums.FilterClick)}
                          className="btn btn-submit"
                          icon={"fa fa-filter"}
                          value=""
                        />
                      </Tooltip>
                      <Tooltip
                        title="export to excel"
                        style={{ marginLeft: "5px", cursor: "pointer" }}
                      >
                        <button
                          className="btn btn-submit"
                          onClick={() =>
                            handleEvents(DRREnums.ExportToExcelClick)
                          }
                        >
                          <i className="fa fa-download"></i>
                        </button>
                      </Tooltip>
                      {context?.CurrentRoleId === RoleEnum.Admin && (
                        <Tooltip
                          title="Initiate Recovery"
                          style={{ marginLeft: "5px", cursor: "pointer" }}
                        >
                          <button
                            className="btn btn-submit"
                            //commented by Imman on 17-07-2024
                            // onClick={(e) => {
                            //   e.preventDefault();
                            //   navigate("/DemandRecoveryForm", {
                            //     state: {
                            //       memberId: 52,
                            //     },
                            //   });
                            // }}
                            //added by Imman on 17-07-2024
                            onClick={() => {
                              setShowPopUp(true);
                            }}
                          >
                            <i className="fas fa-recycle"></i>
                          </button>
                        </Tooltip>
                      )}
                      {/* <Tooltip
                        title="View"
                        style={{ marginLeft: "5px", cursor: "pointer" }}
                      >
                        <button
                          className="btn btn-submit"
                          onClick={() =>
                            handleEvents(DRREnums.ExportToExcelClick)
                          }
                        >
                          <i className="fas fa-eye"></i>
                        </button>
                      </Tooltip> */}

                      {/* <Tooltip title="View">
                        <a
                          onClick={(e) => {
                            e.preventDefault();

                            if (
                              context?.CurrentRoleId === RoleEnum.Admin ||
                              RoleEnum.Member
                            ) {
                              navigate("/DemandRecoveryForm", {
                                state: {
                                  // memberId: tableMeta.rowData[37],
                                },
                              });
                            }
                          }}
                        >
                          <i className="fas fa-eye"></i>
                        </a>
                      </Tooltip> */}
                    </div>
                  </div>
                </div>
                {/* </div> */}
              </div>
            </div>
          </div>

          <DRRFilters
            activeTab={tabs.find((t) => t.active)}
            dashboardFilterOn={dashboardFilterOn}
            setCurrentFilters={setCurrentFilters}
          />

          <DRRGrid
            searchText={searchText}
            setSearchText={setSearchText}
            activeTab={tabs.find((t) => t.active)}
            currentFilters={currentFilters}
            dataCount={dataCount}
            setDataCount={setDataCount}
            setCurrentDataReqObj={setCurrentDataReqObj}
          />

          {/* added by Imman on 17-07-2024 */}
          <div className="ModalSize">
            <Modal
              ariaHideApp={false}
              isOpen={showPopUp}
              contentLabel="Unit Codes"
              style={{
                content: {
                  width: "30%",
                  top: "50%",
                  left: "50%",
                  right: "auto",
                  bottom: "auto",
                  marginRight: "-50%",
                  transform: "translate(-50%, -50%)",
                  backgroundColor: "#ffffff",
                  zIndex: "999",

                  Height: "48%",
                },
              }}
            >
              <div className="col-lg-12 p-0">
                <div className="row">
                  <div
                    className="col-lg-12 col-md-12"
                    style={{ marginBottom: "15px" }}
                  >
                    <div className="form-group">
                      <label className="col-form-label">Member No.</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Member No."
                        value={keywords}
                        onChange={(e: any) => setKeywords(e.target.value)}
                        onKeyDown={(e: any) => {
                          // onKeyDown also fires for control keys, which the
                          // deprecated onKeyPress never did — let those through.
                          if (e.ctrlKey || e.metaKey || e.key.length > 1) {
                            return;
                          }
                          if (!/[0-9]/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        onPaste={(e: any) => {
                          e.preventDefault();
                          const paste = (
                            e.clipboardData || window.ClipboardEvent
                          ).getData("text");
                          if (/^\d+$/.test(paste)) {
                            setKeywords(paste);
                          }
                        }}
                        style={{ width: "90%", position: "fixed", left: "5%" }}
                      ></input>
                    </div>
                  </div>
                  <div
                    className="col-lg-12 col-md-12"
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      padding: "10px",
                    }}
                  >
                    <button
                      className="btn btn-submit"
                      style={{
                        marginRight: "10px",
                        position: "relative",
                        top: "54%",
                      }}
                      onClick={(e) => {
                        e.preventDefault();

                        if (
                          context?.CurrentRoleId === RoleEnum.Admin ||
                          RoleEnum.Member
                        ) {
                          navigate("/DemandRecoveryForm", {
                            state: {
                              memberId: keywords,
                            },
                          });
                        }
                      }}
                    >
                      <i className="fas fa-paper-plane"></i> Submit
                    </button>
                    <button
                      style={{ position: "relative", top: "50%" }}
                      className="btn btn-cancel"
                      onClick={() => setShowPopUp(false)}
                    >
                      <i className="far fa-times-circle"></i> Cancel
                    </button>
                  </div>
                </div>
              </div>
            </Modal>
          </div>

          {/* end */}
        </div>
      </div>
    </>
  );
};

export default DemandRecoveryDashboard;
